import "./index.css"

import React, { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import languageIcon from "../../assets/common/language.svg"
import languageIconDark from "../../assets/common/language_dark.svg"
import flag from "../../assets/Header_Icons/flag.svg"
import { useDarkMode } from "../../context/DarkModeContext"
import { GlobalContext } from "../../context/GlobalContext"
import { useGetLanguageList } from "../../services/queries"
import { getExternalUserDataBasedOnCountry } from "../../utils/utils"
import CustomDropdown from "../Common/Form/Dropdown"

const CountrySelect = () => {
    const { i18n } = useTranslation()
    const { isDarkMode } = useDarkMode()
    const { data: langaguagesList }  = useGetLanguageList()
    
    // Choose language icon based on dark mode
    const languageImage = isDarkMode ? languageIconDark : languageIcon
    const [defaultLanguage, setDefaultLanguage] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [globalLanguageOptions, setGlobalLanguageOptions] = useState([])
    const { setselectedLanguage, setGlobalLanguageChange, userCountryDetails } = useContext(GlobalContext)
 
    const onLanguageSelect = (lng) => {
        i18n.changeLanguage(lng.code)
        localStorage.setItem("selectedLanguage", lng.code)
        localStorage.setItem("selectedLanguageId",  lng.value)
        setselectedLanguage(lng.code)
        setGlobalLanguageChange(lng.value)
        setDefaultLanguage(lng.code)
    }
    useEffect(()=>{
        localStorage.setItem("defaultLanguage",  defaultLanguage)
    },[defaultLanguage])

    useEffect(()=>{
        let finalLanguageData = []
        let languageData = getExternalUserDataBasedOnCountry(langaguagesList, userCountryDetails, true )
        if(languageData?.length > 0 && languageData){
            finalLanguageData = languageData
        }else{
            finalLanguageData = langaguagesList
        }
        const globalLanguageOptions = finalLanguageData?.map((language) => {
            return { value: language?.id, label: language?.name,code: language?.code?.toLowerCase() }
        }).sort((a,b) => {
            if (a.label === b.label) {
                return 0
            }
            return a.label > b.label ? 1 : -1
        })

        setGlobalLanguageOptions(globalLanguageOptions)
    },[userCountryDetails, langaguagesList])
   
    const defaultLanguageCode = (languagesData) => {
        const defaultLan = languagesData.find((language) => {
            return language.is_default
        })

        return defaultLan.id
    }

    useEffect(()=>{
        const userDetails = sessionStorage.getItem("userDetails")
        const defaultLangValueFromStorage =  userDetails ? JSON.parse(userDetails) : []

        const languageDetails = defaultLangValueFromStorage?.languages || []
        const selectedLanguage = localStorage.getItem("selectedLanguage")
        let defaultLanguage = globalLanguageOptions?.find((lang)=> 
            lang?.code === languageDetails[0]?.code.toLowerCase())
        if (selectedLanguage) {
            defaultLanguage = globalLanguageOptions?.find((lang)=> 
                lang?.code === selectedLanguage)
        } 
        if(defaultLanguage && globalLanguageOptions.length) {
            setDefaultLanguage(defaultLanguage.value)
            localStorage.setItem("selectedLanguage", defaultLanguage?.code)
            i18n.changeLanguage(defaultLanguage.code)
            setIsLoading(true)
        } else {
            if(!languageDetails?.length && langaguagesList?.length && !selectedLanguage) {
                let defaultLangId = defaultLanguageCode(langaguagesList)
                setDefaultLanguage(defaultLangId)
                localStorage.setItem("selectedLanguageId",  defaultLangId)
                setIsLoading(true)
            }
        }
    },[globalLanguageOptions])

    return (
        <div className="relative">
            { isLoading && 
                <div className="flex justify-center items-center gap-2">
                    <img src={ `${flag}` } alt="" className="rounded-full hidden" />
                    <div className="flex flex-col justify-center align-start">
                        <div className="text-sm font-semibold text-secondary-50 dark:text-white">
                            <div className="relative top-7">
                                <img
                                    src={ languageImage }
                                    className=""
                                    height={ "16px" }
                                    width={ "16px" }
                                    alt="language"
                                />
                            </div>
                            <div className="relative left-5 sm:left-4 md:left-5 lg:left-5">
                                <div className="text-xs font-medium text-secondary-200 dark:text-white min-w-40 sm:min-w-48 md:min-w-52 lg:min-w-40 relative">
                                    <label className="lang-size dark:text-white" id="aria-label" 
                                        htmlFor="aria-example-input" style={ { position:"relative",paddingLeft:"2px", 
                                            left:"5px",top:"6px",zIndex:1 } }>
                                        Language
                                    </label>
                                    <div style={ { position:"relative",top:"-2px", left:"0px" } }>
                                        <CustomDropdown
                                            aria-labelledby="aria-label"
                                            inputId="aria-example-input"
                                            placeholder={ "" }
                                            defaultValue={ defaultLanguage }
                                            options={ globalLanguageOptions || [] }
                                            name="language"
                                            changeHandler={ onLanguageSelect }
                                            errorData={ [] }
                                            isRequired={ false }
                                            isMulti={ false }
                                            disabled={ false }
                                            className = { "withoutLabel" }
                                            menuPlacement="auto"
                                            menuPosition="fixed"
                                        />
                                    </div>
                                </div>
                                
                            </div> 
                           
                        </div>
                    </div>                    
                </div>
            }
        </div>
    )
}
 
export default CountrySelect
